import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isNative: false,
  platform: 'web',
  deviceInfo: null,
  keyboardVisible: false,
};

const nativeSlice = createSlice({
  name: 'native',
  initialState,
  reducers: {
    setNativeInfo: (state, action) => {
      state.isNative = action.payload?.isNative ?? false;
      state.platform = action.payload?.platform ?? 'web';
      state.deviceInfo = action.payload?.deviceInfo ?? null;
    },
    setKeyboardVisible: (state, action) => {
      state.keyboardVisible = action.payload;
    },
  },
});

export const { setNativeInfo, setKeyboardVisible } = nativeSlice.actions;
export default nativeSlice.reducer;
